import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map } from 'rxjs/operators';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { environment } from '../../../environments/environment';
import { ServicePathsSettings } from '../../core/configuration/service-paths-settings';
import { UrlSettingsCore } from '../../core/configuration/url-settings-core';
import { UserManager } from '../../core/services/user-manager';
import { Subscription } from 'rxjs';
import { PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OauthService } from 'src/app/oauth.service';
// import { PdaConfigurationService } from 'src/app/pda/utils/Service/pda-config.service';
import { SsoStrategyService } from 'src/app/sso-strategy.service';
import { AppData } from 'src/app/data-store';
import { OutlookAuthService } from 'src/app/core/components/login/outlook-auth-lp/outlook-auth.service';
import { PdaConfigurationService } from 'src/app/pda/utils/Service/pda-config.service';
@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {

  private subModal: Subscription;

  private counter : number = 0;

  private callExceptions: string[] = [];

  constructor(
    private modalNotifyService: ModalNotifyService,
    private userManager: UserManager,
    private router: Router,
    private helpers: HelpersService,
    private authPda: PdaAuthService,
    private dialog: DialogService,
    private oAuthService: OauthService,
    // private pdaConfig: PdaConfigurationService,
    private ssoStrategy: SsoStrategyService,
    private authLp: OutlookAuthService,
    private pdaConfig: PdaConfigurationService
  ) {
  }


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (this.callExceptions.every((service) => !~req.url.indexOf(service)) && !req.url.includes(this.pdaConfig.getBaseUrl())) {
      const smUser = localStorage.getItem('TLF_USER');
      if(!req.url.includes("/"+ environment.keycloak.context +"/")) {
        // req = req.clone({setHeaders: this.setHeaders(smUser), withCredentials: true});
        req = req.clone({setHeaders: this.setHeaders(smUser)});
      }

    }

    // controllo se è presente lo SKIP dell'interceptor
    if (req.context.get(SKIP_ERROR_INTERCEPTOR)) {
      return next.handle(req);
    }

    return this.handlePipe(req, next);

  }


  private setHeaders(smUser: string): { [name: string]: string | string[]; } {
    let token = localStorage.getItem('access_token');
    if(this.ssoStrategy.getAuthMode() === "ldap") {
      if(smUser) {
        return {
          'TLF_PRODUCT': 'teleforum',
          'TLF_USER': smUser
        };
      }
    } else if(this.ssoStrategy.getAuthMode() === "oauth2") {
      // const payload = JSON.parse(atob(token?.split('.')[1]));
      return {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'TLF_PRODUCT': 'teleforum',
        // 'TLF_USER': payload.preferred_username
      };
    }
  }

  private modifyBody(body: any) {
    if (body && body['meta-info']) {
      body = {
        ...body,
        ...{
          httpCode: body['meta-info']['http-code'],
          returnCode: body['meta-info']['return-code'],
          okMessages: body['meta-info']['ok-messages'],
          koMessages: body['meta-info']['ko-messages'],
          exceptionMessage: body['meta-info']['exception-message'],
          operationTime: body['meta-info']['operation-time'],
        },
      };
    }
    return body;
  }


  private handlePipe(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {

        /* Se la risposta è positiva, cambio il body formattandola secondo le proprietà precedenti del vecchio framework */
        if (event instanceof HttpResponse) {
          event = event.clone({ body: this.modifyBody(event.body) });
        }
        return event;

      }),
      catchError((err) => {

        if (req.url.includes('/protocols/offices/')) {
          return throwError(() => err); 
        }
        /* Se la risposta è negativa, inizializza un messaggio di errore a seconda dell'error code e chiama il messageService */
        if((typeof err.error == "string" && err.error.includes("PST")) || req.url.includes('processotelematico') || req.url.includes(this.pdaConfig.getBaseUrl())) {
          return of(!~req.url.indexOf('report/SSO') ? err : null);
        }

        if(err instanceof HttpErrorResponse && req.url.includes("/"+ environment.keycloak.context +"/") && req.url.endsWith("token")){
          // this.authLp.onTokenError({error: "invalid_token"});
          this.checkIdTokenAndLogoutLogin();
        }

        if (err instanceof HttpErrorResponse && !req.url.includes("/"+ environment.keycloak.context +"/")) { //LA LOGIN DEI REPORT non DEVE GENERARE UN ERRORE
          if(err.status === 401 && !req.url.endsWith("/logout")) {
            if(this.ssoStrategy.getAuthMode() === "oauth2") {
              this.checkIdTokenAndLogoutLogin();
            } else {
              this.gotoLogin(err);
            }
          } 
          if (err.status === 403 || this.isNoGrants500Error(err)) {
            req['cycle'] = req['cycle'] ? req['cycle'] + 1 : 1;
            if (req['cycle'] < 3) {
              return this.handlePipe(req, next);
            }
            if(this.ssoStrategy.getAuthMode() === "ldap") {
              this.gotoLogin(err);
            }
          } else {
          //   this.openErrorDialog("L'operazione non è andata a buon fine.")
            /* this.modalNotifyService.customMessage(
              "L'operazione non è andata a buon fine."
            ); */
            try {
              let errorMessage: string = err.error && err.error.message ? err.error.message : err.error.replace(/<[^>]*>?/gm, '');
              //Riconoscimento stack trace
              if(errorMessage.toLowerCase().match("[^ ]*[.][^ ]*[.][^ ]*[exception].*"))
                this.openErrorDialog("L'operazione non è andata a buon fine.");
              else
                this.openErrorDialog(errorMessage);
              // //debug:
              // console.log("Errore nella chiamata "+req.url+": "+errorMessage);
              // if (err.error && err.error.message) {
              //   this.openErrorDialog(err.error.message);
              // } else if (err.error && typeof err.error === 'string') {
              //   const str = err.error.replace(/<[^>]*>?/gm, '');
              //   this.openErrorDialog(str);
              // } else {
              //   this.openErrorDialog(
              //     "L'operazione non è andata a buon fine."
              //   );
              // }
            } catch (e) {
              this.openErrorDialog(err.message);
            }

          }

        }

        if(req.url.endsWith('fascicolo/JUSTICE_PDA')){
          return throwError(err);
        }

        // LA LOGIN DEI REPORT NON DEVE VINCOLARE LA LOGIN PRINCIPALE
        // tslint:disable-next-line:no-bitwise
        // return of(!~req.url.indexOf('report/SSO') ? err : null);
        return throwError(() => err); 
      })
    );
  }


  private checkIdTokenAndLogoutLogin() {
    if (this.oAuthService.isTokenIdValid()) {
      this.oAuthService.invalidateTokenSession();
    } else {
      // nel caso in cui id token hint fosse nullo o invalido bypasso la logout
      // pulisco la sessione e accedo nuovamente
      this.oAuthService.clearOAuthData();
      this.oAuthService.redirectToKeycloak(AppData.getInstance().idpHint);
    }
  }

  /**
   * In some cases no grants error are managed by 500-code-error in
   * filter class SessionLoggedUserFilter.java
   *
   */
  private isNoGrants500Error(err: HttpErrorResponse) : boolean {

    if(err.status !== 500) { return false; }

    const ERR_500_NO_GRANTS = 'Accesso a funzionalità protetta senza autenticazione: Accesso NON consentito.'
      .toLowerCase();

    let text = err.error ?? '';
    text = text?.toLowerCase();

    return text == ERR_500_NO_GRANTS;

  }


  private gotoLogin(err: HttpErrorResponse) {

    this.userManager.sendUserLogged(false);
    this.userManager.clearUser();
    this.userManager.clearUserLogged();

    if (environment.sso) {

      window.location.href =
        ServicePathsSettings.DOMINIO + '/' + UrlSettingsCore.URL_SSO;

    } else {
      /**
       * In case of wrong credentials > specific msg from BE
       * otherwise always "Sessione scaduta" to avoid AS messages
       */
      let wrongCredentials = true;
      let errMsg = err.error;
      if (errMsg && typeof errMsg == "string") {
        errMsg = errMsg.toLowerCase();
        wrongCredentials =
          errMsg.indexOf("username") >= 0 || errMsg.indexOf("password") >= 0;
        errMsg = wrongCredentials ? err.error : "Sessione scaduta";
      }

      this.router.navigate([UrlSettingsCore.URL_LOGIN]);

      // The modal will be opened only if no other calls passed through this point
      this.counter++;
      this.subModal = this.modalNotifyService.notifyConfirmObservable.subscribe(result =>{
        //Clicking on OK or Chiudi, the counter will be reset and other modals could be showed
        this.counter = 0;
        this.subModal.unsubscribe();
      });
      this.counter <= 1 && this.modalNotifyService.notifyOkWithCallback('Errore', errMsg)

    }
  }

  openErrorDialog(message:string){
    this.dialog.removeDialogComponentFromBody();
    this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: message,
          data: [],
          hideButtons: true,
          confirmButton :true
        },
        style: {
          width: '50%',
          zIndex: '9999999 !important'
        },
        title: 'Conferma',
      }
    });

  }

}

export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
